export type PlatformRoute = "home" | "creators" | "partners" | "missing";

/** Exact routes only: the platform host must not turn arbitrary paths into landing pages. */
export function platformRoute(pathname: string): PlatformRoute {
  const path = pathname.replace(/\/+$/, "") || "/";
  if (path === "/") return "home";
  if (path === "/creators") return "creators";
  if (path === "/partners") return "partners";
  return "missing";
}
